import { Link } from "@mui/material";
import { GridCellParams } from "@mui/x-data-grid";
import { Link as RouterLink } from "react-router-dom";
import { Hospital } from "../hospital/type";

export default function HospitalsDetailButton(props: GridCellParams<Hospital, any>) {
    return <Link component={RouterLink} to={props.row.id.toString()}>Detay</Link>
}